import React from 'react';

function loadRazorpay (props) {
  var options = {
    key: props.app_key,
    amount: props.price_cents,
    currency: props.price_currency,
    name: props.name,
    description: props.description
  };
  props.previewSubscription().then((previewResponse) => {
    const attemptToken = previewResponse;
    Object.assign(options, { notes: { attemptToken: attemptToken } });
    if (props.recurring) {
      props.createSubscriptionToken(attemptToken).then(response => {
        const razorpaySubscriptionId = response.body.subscription.id;
        new window.Razorpay(Object.assign(options, {
          subscription_id: razorpaySubscriptionId,
          handler: (response) => props.onComplete(razorpaySubscriptionId, attemptToken)
        })).open();
      });
    } else {
      new window.Razorpay(Object.assign(options, {
        handler: (response) => props.onComplete(response.razorpay_payment_id, attemptToken)
      })).open();
    }
  });
}

export default function RazorpayButton (props) {
  return <button onClick={(e) => { e.preventDefault(); loadRazorpay(props); }}>{props.children}</button>;
}
